import React, { createContext, useContext, useState, useCallback } from 'react';

const FlightLogCtx = createContext(null);

export function FlightLogProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const open  = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);
  return (
    <FlightLogCtx.Provider value={{ isOpen, open, close }}>
      {children}
    </FlightLogCtx.Provider>
  );
}

export const useFlightLog = () => useContext(FlightLogCtx);
